import { useQuery } from 'react-query';
import { getProvinces } from 'src/services/api/provinces';

function useGetProvinces(params) {
  return useQuery(['provinces', params], () => getProvinces(params));
}

export default useGetProvinces;
